import React from 'react';
import Navigation from '../components/Navigation';
import OrganizationManager from '../components/OrganizationManager';
import './Organizations.css';

const Home = () => {
  return (
    <div>
      <Navigation />
      <div className="content">
      <OrganizationManager />
      </div>
    </div>
  );
};

export default Home;
